(() => {
  "use strict";

  const DISCOUNT_CODE = "PICKUP10";
  const CHECKBOX_ID = "selfPickupCheckbox";

  function initSelfPickupCheckbox() {
    const checkbox = document.getElementById(CHECKBOX_ID);
    if (!checkbox) return;

    // Avoid double-binding if theme re-renders sections
    if (checkbox.dataset.bound === "true") return;
    checkbox.dataset.bound = "true";

    const variantId = checkbox.getAttribute("data-variant-id") || "unknown";
    const productTitle = checkbox.getAttribute("data-product-title") || "";

    // Restore state from localStorage
    const key = `selfPickupChecked-${variantId}`;
    const saved = localStorage.getItem(key);
    const isChecked = saved === "true";

    checkbox.checked = isChecked;
    updateSelfPickupState(isChecked, variantId, productTitle);

    checkbox.addEventListener("change", () => {
      const next = checkbox.checked;
      localStorage.setItem(key, String(next));
      updateSelfPickupState(next, variantId, productTitle);
    });
  }

  function updateSelfPickupState(isChecked, variantId, productTitle) {
    console.log("[SelfPickup]", { isChecked, variantId, productTitle });

    if (isChecked) {
      applyDiscountCode(DISCOUNT_CODE);
    } else {
      clearDiscountCookies();
      // Optional: if you want the cart UI to reflect instantly, uncomment:
      // window.location.reload();
    }
  }

  function applyDiscountCode(code) {
    // /discount/CODE sets the discount cookie via redirect. We need credentials so it sticks.
    fetch(`/discount/${encodeURIComponent(code)}`, {
      method: "GET",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then((res) => {
        if (res.ok) {
          console.log(`[Discount] Applied: ${code}`);
        } else {
          console.error(`[Discount] Failed to apply: ${code}`);
        }
      })
      .catch((err) => console.error("[Discount] Apply error:", err));
  }

  function clearDiscountCookies() {
    // Shopify discount cookie names vary by setup; clear the usual suspects.
    const names = [
      "discount_code",
      "discount_codes",
      "discount",
      "discountCode",
      "applied_discount_code"
    ];

    const expired = "Thu, 01 Jan 1970 00:00:00 GMT";
    names.forEach((name) => {
      document.cookie = `${name}=; expires=${expired}; path=/`;
      // Some shops end up with domain-scoped cookies; attempt a best-effort clear.
      document.cookie = `${name}=; expires=${expired}; path=/; domain=${location.hostname}`;
      document.cookie = `${name}=; expires=${expired}; path=/; domain=.${location.hostname}`;
    });

    console.log("[Discount] Cleared discount cookies (best effort).");
  }

  // Init on first load
  document.addEventListener("DOMContentLoaded", initSelfPickupCheckbox);

  // Re-init for Shopify theme editor / section reloads
  document.addEventListener("shopify:section:load", initSelfPickupCheckbox);
  document.addEventListener("shopify:section:select", initSelfPickupCheckbox);
})();
